import React, { FormEvent, useContext, useEffect, useState } from "react";
import { Grid, Segment, Form, Button, Popup, Dropdown, Table, Checkbox, Input, List, Message, Modal } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import EmployeeTimeSheetStore from "../../../app/stores/employeetimesheetStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import TextareaAutosize from "react-textarea-autosize";
import { ITimeSheet } from "../../../app/models/timesheet";

const EmplyeeTimeSheetForm: React.FC = () => {
  const employeetimesheetStore = useContext(EmployeeTimeSheetStore);
  const {
    submitting,
    loadPayrollCycles,
    payrollcycleRegistry,
    loadEmployeeTimeSheets,
    editEmployeeTimeSheets,
    loadProjectTimes,
    payrunstatusByDate,
    projecttimeRegistry,
    selectPayRun,
    inputError,
  } = employeetimesheetStore;

  useEffect(() => {
    loadPayrollCycles().then(() => loadEmployeeTimeSheets()).then((payrun) => 
      selectPayRun(payrun)).then((timesheet) => {
        const newassign = timesheet.map(object => ({ ...object }));
        setEmployeeTime(newassign);
        const run = timesheet[0].financeYear + '-' + timesheet[0].payRun;
            setSelectedPayrun(run);
      });
      loadProjectTimes();
  }, []);

  const [employeeTime, setEmployeeTime] = useState<ITimeSheet[]>([]);
  const [selectedPayrun, setSelectedPayrun] = useState('');
  const [modalIndex, setModalIndex] = useState(-1)
  const [requiredOnsite, setRequiredOnsite] = useState(false);
  const [requiredOffsite, setRequiredOffsite] = useState(false);
  const [timeCheck, setTimeCheck] = useState(false);

  if (employeetimesheetStore.loadingInitial)
    return <LoadingComponent content="Loading time sheet..." />;

  // const handleSubmit = () => {
  //   editEmployeeTimeSheets(employeeTime);
  // };

  const payrunstatusOptions = payrunstatusByDate.map(function (pay) {
    var option = { "key": pay.payRun, 
                  "text": <div> <strong>{pay.payRun}</strong>&nbsp;&nbsp;({pay.financeYear}) -  <i>{pay.status}</i></div>, 
                  "value": pay.financeYear + '-' + pay.payRun }
    return option;
  }
  );

  const projecttypeOptions = Array.from(projecttimeRegistry.values()).map(function (item) {
    var option = { "key": item.code, "text": item.code, "value": item.code }
    return option;
  }
  );

  projecttypeOptions.push(projecttypeOptions.splice(projecttypeOptions.findIndex(v => v.key == 'OTHERS'), 1)[0]);

  function getDayOfWeek(date: string) {
    const dayOfWeek = new Date(date).getDay();    
    return isNaN(dayOfWeek) ? null : 
      ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek];
  }

  // const projecttypeOptions = [{ key: "RFI-OPT", text: 'RFI-OPT', value: "RFI-OPT" },
  //                   { key: "RFI-TPG", text: "RFI-TPG", value: "RFI-TPG" },
  //                   { key: "EFI-TX", text: "EFI-TX", value: "EFI-TX" },
  //                   { key: "LLS-OPT", text: "LLS-OPT", value: "LLS-OPT" },
  //                   { key: "CAM-TX", text: "CAM-TX", value: "CAM-TX" },
  //                   { key: "TEQA-QR", text: "TEQA-QR", value: "TEQA-QR" },
  //                   { key: "BDOD", text: "BDOD", value: "BDOD" },
  //                   { key: "N2P", text: "N2P", value: "N2P" },
  //                   { key: "WWS", text: "WWS", value: "WWS" },
  //                   { key: "CN-TEL", text: "CN-TEL", value: "CN-TEL" },
  //                   { key: "OTHERS", text: "OTHERS", value: "OTHERS" }];
  const fulldayOptions = [{ key: 'Full Day', text: 'Full Day', value: '1' },
                    { key: "Half Day", text: "Half Day", value: '0.5' }];
  
  function addDays(myDate: string, days: number) {
    return new Date(new Date(myDate).getTime() + days*24*60*60*1000).toISOString().substr(0, 10);
  }

  function convertDate(date: string) {
    var arrDate = date.split("-");
    return arrDate[2] + "/" +arrDate[1] + "/" + arrDate[0];
  } 

  function totalDays() {
    let total = 0;
    employeeTime.map((time) => {
        total = total + Number(time.fullDay);                  
    });
    return total;
  };
  
  function totalWorkingHours() {
    let total = 0;
    employeeTime.map((time) => {
        total = total + Number(time.workingHours);                  
    });
    return total;
  }; 

  function totalOvertimeHours() {
    let total = 0;
    employeeTime.map((time) => {
        total = total + Number(time.overtimeHours);                  
    });
    return total;
  }; 

  function totalWeekendHours() {
    let total = 0;
    employeeTime.map((time) => {
        total = total + Number(time.weekendHours) + Number(time.nightHours);                  
    });
    return total;
  }; 

  function hourDiff(startHour: string, endHour: string) {
    let timeStart = new Date("01/01/2007 " + startHour);
    let timeEnd = new Date("01/01/2007 " + endHour);
    let difference = timeEnd.getTime() - timeStart.getTime();
    let minutes = Math.round(difference / 60000);
    let hours = (minutes/60).toFixed(2);
    return Number(hours);
  }; 

  return (
    <Segment clearing>
      <Form>
        <Grid columns={2}>
          <Grid.Column  mobile={16} tablet={6} computer={3}>
          <Dropdown 
            placeholder='Select Pay Run'
            options={payrunstatusOptions} 
            selection
            onChange={(e, {value}) => selectPayRun(String(value)).then((timesheet) => {
              const newassign = timesheet.map(object => ({ ...object }));
              setEmployeeTime(newassign)}).then(
                () => setSelectedPayrun(String(value)))} 
            value={selectedPayrun}
          />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={10} computer={5}>
            <List>
              <List.Item style={{color: 'gold', fontWeight: 'bold'}}> {payrollcycleRegistry.get(selectedPayrun) &&
                 'Week 1: \xa0\xa0\xa0\xa0\xa0\xa0' + 
                 convertDate(payrollcycleRegistry.get(selectedPayrun).startDate.substr(0, 10)) +
                 '\xa0\xa0 - \xa0\xa0' + 
                 convertDate(addDays(payrollcycleRegistry.get(selectedPayrun).startDate.substr(0, 10), 6))}
              </List.Item>
              <List.Item style={{color: 'limegreen', fontWeight: 'bold'}}>
                 {payrollcycleRegistry.get(selectedPayrun) &&
                 'Week 2: \xa0\xa0\xa0\xa0\xa0\xa0' + 
                 convertDate(addDays(payrollcycleRegistry.get(selectedPayrun).startDate.substr(0, 10), 7)) +
                 '\xa0\xa0 - \xa0\xa0' + 
                 convertDate(addDays(payrollcycleRegistry.get(selectedPayrun).startDate.substr(0, 10), 13))}
              </List.Item>
            </List>
          </Grid.Column>
        </Grid>
        {employeeTime.map(time => {
           if (time.remark !== '')
           return (
            <Message style={{backgroundColor: 'lightyellow'}}>
            <strong>Remark for {time.attendanceDate.substr(8,2)+'/'+time.attendanceDate.substr(5,2)}</strong>: {time.remark}
           </Message>
           )
        })}
        <Table celled compact unstackable size='small'>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell width='1'>Date</Table.HeaderCell>
        {/* <Table.HeaderCell width='1'  style={{paddingLeft: '0', paddingRight: '0'}}>Attend</Table.HeaderCell> */}
        <Table.HeaderCell>Project</Table.HeaderCell>
        <Table.HeaderCell>Day</Table.HeaderCell>
        <Table.HeaderCell>Site</Table.HeaderCell>
        <Table.HeaderCell>
          <p style={{margin: '0'}}>Onsite</p>
          <p style={{margin: '0'}}>Time</p>
        </Table.HeaderCell>
        <Table.HeaderCell>
          <p style={{margin: '0'}}>Offsite</p>
          <p style={{margin: '0'}}>Time</p>
        </Table.HeaderCell>
        <Table.HeaderCell>
          <p style={{margin: '0'}}>Working</p>
          <p style={{margin: '0'}}>hours</p>
        </Table.HeaderCell>
        <Table.HeaderCell>
          <p style={{margin: '0'}}>Overtime</p>
          <p style={{margin: '0'}}>hours</p>
        </Table.HeaderCell>
        <Table.HeaderCell>
          <p style={{margin: '0'}}>Night/</p>
          <p style={{margin: '0'}}>Weekend</p>
          <p style={{margin: '0'}}>hours</p>
        </Table.HeaderCell>
        <Table.HeaderCell>LAHFA</Table.HeaderCell>        
      </Table.Row>
    </Table.Header>

    <Table.Body>
    {employeeTime.map((time, index) => (
      <Table.Row key={time.id} active={(time.attendant === 'Y')}>
        <Table.Cell>
          <Modal
            // onClose={() => setModalIndex(-1)}
            onOpen={() => setModalIndex(index)}
            open={(modalIndex === index)}
            trigger={<Button
              color={(index < 7) ? 'yellow' : 'green'}
              size='mini'
              compact
              disabled={(!employeeTime[0]) || 
                ((employeeTime[0].status !== "New") && (employeeTime[0].status !== "Rejected") 
                && (employeeTime[0].status !== "Saved"))}
             >
             <strong >{time.attendanceDate.substr(8,2)+'/'+time.attendanceDate.substr(5,2)}</strong>
             <p>{getDayOfWeek(time.attendanceDate)}</p>
             </Button>}
          >
          <Modal.Header>
            <strong>{convertDate(time.attendanceDate.substr(0,10))+'\xa0\xa0\xa0\xa0\xa0\xa0'+
            getDayOfWeek(time.attendanceDate)}</strong>
          </Modal.Header>
          <Modal.Content>
          <Form>
          <Form.Select
            label='Project'
            onChange={(e, { name, value }) => {
              let newArr = [...employeeTime];
              newArr[index]['projectType'] = String(value);
              if (value !== '') 
              {
                newArr[index]['attendant'] = 'Y'
                if ((projecttimeRegistry.get(String(value))) && 
                (projecttimeRegistry.get(String(value)).type === 'Daily'))
                {
                  newArr[index]['fullDay'] = '1'
                }
                else
                {
                  newArr[index]['fullDay'] = '0'
                }
              }
              else 
              {
                newArr[index]['attendant'] = 'N';
                newArr[index]['fullDay'] = '0';
                newArr[index]['site'] = '';
                newArr[index]['onsiteTime'] = '';
                newArr[index]['offsiteTime'] = '';
                newArr[index]['overtimeHours'] = '0';
                newArr[index]['weekendHours'] = '0';
                newArr[index]['workingHours'] = 0;
                newArr[index]['lahfa'] = 'No LAHFA';
              }
              setEmployeeTime(newArr);
            }}
            error={inputError && (time.attendant === 'Y') && (!time.projectType) && { content: 'Please select', pointing: 'below' }}
            name="projectType"
            options={projecttypeOptions}
            value={time.projectType}
            clearable
          />
          { (projecttimeRegistry.get(time.projectType)) && 
        (projecttimeRegistry.get(time.projectType).type === 'Daily') &&
          <Form.Select
            label='Day'
            onChange={(e, { name, value }) => {
              let newArr = [...employeeTime];
              newArr[index]['fullDay'] = String(value);
              setEmployeeTime(newArr);
            }}
            name="fullDay"
            options={fulldayOptions}
            value={String(time.fullDay)}
          />}
          { (projecttimeRegistry.get(time.projectType)) && 
        (projecttimeRegistry.get(time.projectType).type === 'Daily') &&
          <Form.Field
          label='Site'
          control={TextareaAutosize}
          rows={1}
          onChange={(e: any) => {
            let newArr = [...employeeTime];
            newArr[index]['site'] = e.currentTarget.value;
            setEmployeeTime(newArr);
          }}
          value={time.site}
          // style={{border: 'none', padding: '0.3em 0em', minWidth: '110px'}}
        />}
        { (projecttimeRegistry.get(time.projectType)) && 
        (projecttimeRegistry.get(time.projectType).type === 'Hourly') &&
        <Form.Group widths="equal">
        <Form.Input
              label='Onsite Time'
              name="onsiteTime"
              type='time'
              onChange={(e: any) => {
                let newArr = [...employeeTime];
                newArr[index]['onsiteTime'] = e.currentTarget.value;
                setEmployeeTime(newArr);
                setRequiredOnsite(false);
                setTimeCheck(false);
              }}
              value={time.onsiteTime}
              error={(requiredOnsite) && 'please input onsite time'}
            />
            <Form.Input
              label='Offsite Time'
              name="offsiteTime"
              type='time'
              onChange={(e: any) => {
                let newArr = [...employeeTime];
                newArr[index]['offsiteTime'] = e.currentTarget.value;
                setEmployeeTime(newArr);
                setRequiredOffsite(false);
                setTimeCheck(false);
              }}
              value={time.offsiteTime}
              error={(requiredOffsite) && 'please input offsite time'}
            />
        </Form.Group>}
        {(timeCheck) && <p style={{color: 'red'}}>offsite time must be greater than onsite time</p>}
        { (projecttimeRegistry.get(time.projectType)) && 
        (projecttimeRegistry.get(time.projectType).type !== 'Hourly') &&
        <Form.Input
              label='Overtime Hours'
              name="overtimeHours"
              onChange={(e, { name, value }) => {
                let newArr = [...employeeTime];
                newArr[index]['overtimeHours'] = value;
                setEmployeeTime(newArr);
              }}
              value={time.overtimeHours}
            />}
          { (projecttimeRegistry.get(time.projectType)) && 
        (projecttimeRegistry.get(time.projectType).type !== 'Hourly') &&
        <Form.Input
              label='Night Shift Hours'
              name="nightHours"
              onChange={(e, { name, value }) => {
                let newArr = [...employeeTime];
                newArr[index]['nightHours'] = value;
                setEmployeeTime(newArr);
              }}
              value={time.nightHours}
            />}
        { (projecttimeRegistry.get(time.projectType)) && 
        <Form.Group inline>
          <label>LAHFA</label>
          <Form.Radio
            label='No LAHFA'
            value='No LAHFA'
            checked={time.lahfa === 'No LAHFA'}
            onChange={(e, { name, value }) => {
              let newArr = [...employeeTime];
              newArr[index]['lahfa'] = String(value);
              setEmployeeTime(newArr);
            }}
          />
          <Form.Radio
            label='LAHFA with accomodation'
            value='LAHFA with accomodation'
            checked={time.lahfa === 'LAHFA with accomodation'}
            onChange={(e, { name, value }) => {
              let newArr = [...employeeTime];
              newArr[index]['lahfa'] = String(value);
              setEmployeeTime(newArr);
            }}
          />
          <Form.Radio
            label='LAHFA without accomodation'
            value='LAHFA without accomodation'
            checked={time.lahfa === 'LAHFA without accomodation'}
            onChange={(e, { name, value }) => {
              let newArr = [...employeeTime];
              newArr[index]['lahfa'] = String(value);
              setEmployeeTime(newArr);
            }}
          />
        </Form.Group>}
        </Form>   
        </Modal.Content>
        <Modal.Actions>      
        <Button
          content="Done"
          onClick={() => {
            if ((projecttimeRegistry.get(time.projectType)) && 
                (projecttimeRegistry.get(time.projectType).type === 'Hourly'))
            {
               if (time.onsiteTime === '' || time.offsiteTime === '')
               {
                if (time.onsiteTime === '') setRequiredOnsite(true);
                if (time.offsiteTime === '') setRequiredOffsite(true);
               }
               else
               { 
                 if (hourDiff(time.onsiteTime, time.offsiteTime) > 0)
                 {
                   if ((hourDiff('19:00', time.onsiteTime) > 0) || (hourDiff(time.offsiteTime, '07:00') > 0))
                   {
                    let newArr = [...employeeTime];
                    newArr[index]['workingHours'] = 8;
                    setEmployeeTime(newArr);
                    setModalIndex(-1);
                   }
                   else if (getDayOfWeek(time.attendanceDate) === 'Saturday')
                   {
                     if ((hourDiff(time.offsiteTime, '13:00') >= 0))
                     {
                      let start = time.onsiteTime;
                      let end = time.offsiteTime;
                      let working = hourDiff(start, end);
                      let newArr = [...employeeTime];
                      newArr[index]['overtimeHours'] = String(working);
                      setEmployeeTime(newArr);
                      setModalIndex(-1);
                     }
                     else
                     {
                      let start = time.onsiteTime;
                      let end = '13:00';
                      let working = hourDiff(start, end);
                      let newArr = [...employeeTime];
                      newArr[index]['overtimeHours'] = String(working);

                      let start1 = '13:00';
                      let end1 = time.offsiteTime;
                      let working1 = hourDiff(start1, end1);
                      newArr[index]['weekendHours'] = String(working1);

                      setEmployeeTime(newArr);
                      setModalIndex(-1);
                     }
                   }
                   else if (getDayOfWeek(time.attendanceDate) === 'Sunday')
                   {
                    let start = time.onsiteTime;
                    let end = time.offsiteTime;
                    let working = hourDiff(start, end);
                    let newArr = [...employeeTime];
                    newArr[index]['weekendHours'] = String(working);
                    setEmployeeTime(newArr);
                    setModalIndex(-1);
                   }
                   else
                   {
                     let start = projecttimeRegistry.get(time.projectType).startTime;
                     let end = projecttimeRegistry.get(time.projectType).endTime;
                    //  if (hourDiff(projecttimeRegistry.get(time.projectType).startTime, time.onsiteTime) > 0) start = time.onsiteTime;
                    //  if (hourDiff(time.offsiteTime, projecttimeRegistry.get(time.projectType).endTime) > 0) end = time.offsiteTime;
                     let businessWorking = hourDiff(start, end) - (projecttimeRegistry.get(time.projectType).lunch / 60);
                     start = time.onsiteTime;
                     end = time.offsiteTime;
                     let actualWorking = hourDiff(start, end) - (projecttimeRegistry.get(time.projectType).lunch / 60);
                     let working = (businessWorking > actualWorking) ? Number(actualWorking.toFixed(2)) : Number(businessWorking.toFixed(2));
                  //   let overtime = ((actualWorking - businessWorking) > 0.5) ? Number((actualWorking - businessWorking).toFixed(2)) : 0;
                     let overtime = ((actualWorking - businessWorking) > 0) ? Number((actualWorking - businessWorking).toFixed(2)) : 0;
                     let nighttime = (hourDiff('19:00', time.offsiteTime) > 0) ? hourDiff('19:00', time.offsiteTime) : 0;
                     let newArr = [...employeeTime];
                     newArr[index]['workingHours'] = working;
                     newArr[index]['overtimeHours'] = (overtime > nighttime) ? (overtime - nighttime).toFixed(2) : '0';
                     newArr[index]['nightHours'] = (overtime > nighttime) ? String(nighttime) : '0';
                     setEmployeeTime(newArr);
                     setModalIndex(-1);
                   }
                 }
                 else
                 {
                   setTimeCheck(true);
                 }
               }
            }
            else setModalIndex(-1)}}
          color='green'
        />
        </Modal.Actions>
        </Modal>
        </Table.Cell>
        {/* <Table.Cell style={{padding: '0'}} textAlign='center'>
          <Checkbox  
            checked={time.attendant === 'Y'}
            // onChange={(e, data) => {
            //   let newArr = [...employeeTime];
            //   (data.checked) ? newArr[index]['attendant'] = 'Y' : newArr[index]['attendant'] = 'N';
            //   setEmployeeTime(newArr);
            // }}
            disabled={(!employeeTime[0]) || 
              ((employeeTime[0].status !== "New") && (employeeTime[0].status !== "Rejected") 
              && (employeeTime[0].status !== "Saved"))}
          />
        </Table.Cell> */}
        <Table.Cell style={{padding: '0'}}>
          {time.projectType}
        </Table.Cell>
        <Table.Cell style={{padding: '0'}}>
          {(time.fullDay == '1') ? 'Full' : 
           (time.fullDay == '0.5' ? 'Half' : '')}
        </Table.Cell>
        <Table.Cell style={{padding: '0'}}>
          {time.site}
        </Table.Cell>
        <Table.Cell style={{padding: '0'}}>
          {time.onsiteTime}
        </Table.Cell>
        <Table.Cell style={{padding: '0'}}>
          {time.offsiteTime}
        </Table.Cell>
        <Table.Cell>
          {time.workingHours}
        </Table.Cell>
        <Table.Cell>
          {time.overtimeHours}
        </Table.Cell>
        <Table.Cell>
          {(getDayOfWeek(time.attendanceDate) === 'Saturday' || 
          getDayOfWeek(time.attendanceDate) === 'Sunday') ? time.weekendHours : time.nightHours}
        </Table.Cell>  
        <Table.Cell>
          {time.lahfa}
        </Table.Cell>      
      </Table.Row>
    ))}
    </Table.Body>
    <Table.Footer>
        <Table.Row>
      <Table.HeaderCell>Total:
      </Table.HeaderCell>
      <Table.HeaderCell/>
      <Table.HeaderCell><strong>{totalDays()}</strong>
      </Table.HeaderCell>
      <Table.HeaderCell/>
      <Table.HeaderCell/>
      <Table.HeaderCell/>
      <Table.HeaderCell><strong>{totalWorkingHours().toFixed(2)}</strong>
      </Table.HeaderCell>
      <Table.HeaderCell><strong>{totalOvertimeHours().toFixed(2)}</strong>
      </Table.HeaderCell>
      <Table.HeaderCell><strong>{totalWeekendHours().toFixed(2)}</strong>
      </Table.HeaderCell>
      <Table.HeaderCell/>
      </Table.Row>
      </Table.Footer>
  </Table>
  </Form>
     <Button
          loading={submitting}
          floated='left'
          color='blue'
          content='Save'
          onClick={() => editEmployeeTimeSheets(employeeTime, 'Saved')}
          disabled={(!employeeTime[0]) || 
            ((employeeTime[0].status !== "New") && (employeeTime[0].status !== "Rejected") 
            && (employeeTime[0].status !== "Saved"))}
     />
     <Button
          loading={submitting}
          floated='right'
          positive
          content='Submit'
          onClick={() => editEmployeeTimeSheets(employeeTime, 'Submitted')}
          disabled={(!employeeTime[0]) || 
            ((employeeTime[0].status !== "New") && (employeeTime[0].status !== "Rejected") 
            && (employeeTime[0].status !== "Saved")) || (Date.now() < Date.parse(employeeTime[13].attendanceDate))}
     />
    </Segment>
  );
};

export default observer(EmplyeeTimeSheetForm);
